import SettingsTabs from "../SettingsTab/SettingsTab";

const SettingsTab = () => {
  return <SettingsTabs />;
};

export default SettingsTab;
